<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="ngControl.control" [placeholder]=placeholder>
    <mat-option [value]="null">Don't repeat</mat-option>
    @for (option of options; track option) {
      <mat-option [value]="option">{{ frequencyList[option] | titlecase }}</mat-option>
    }
  </mat-select>
</mat-form-field>
